import { Inject, Injectable } from '@angular/core';
import {
  Router,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
  ActivatedRoute,
} from '@angular/router';
import { IS_SERVER_PLATFORM, UserService } from 'src/app/core';

@Injectable()
export class UserIsLoggedInGuard {
  constructor(
    private router: Router,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    @Inject(IS_SERVER_PLATFORM) private isServer: boolean
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      if (this.isServer) return true;
      if (!!!this.isServer) {
        if (localStorage.getItem('user')) return true;
      }

      this.router.navigate(['/'], {
        queryParams: {
          authBox: 1,
          redirectTo: (route as any)._routerState.url,
        },
      });

      return false;
    } catch (e) {
      return false;
    }
  }
}
